module.exports = __webpack_public_path__ + "img/success-moto.efd5440b.png";